import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { securedAxiosInstance, plainAxiosInstance } from "./api/axios";
import VueAxios from "vue-axios";
import "./index.css";
import { setupI18n, i18nPluginExtended, setupVersionCheck } from "@estaly/ui";
import "flowbite";
import { RollbarPlugin } from "./rollbar";
import "floating-vue/dist/style.css";
import FloatingVue from "floating-vue";
import { usePostHog } from "@/composables/usePostHog";

async function importMessages(locale) {
  return await import(/* webpackChunkName: "locale-[request]" */ `./locales/${locale}.json`);
}

const i18n = setupI18n({ locale: "fr", importMessages });
const app = createApp(App);

app.use(RollbarPlugin);
app.use(store);
app.use(router);
app.use(VueAxios, {
  secured: securedAxiosInstance,
  plain: plainAxiosInstance,
});
app.use(i18n);
app.use(i18nPluginExtended);
app.use(FloatingVue, {
  themes: {
    "info-tooltip": {
      $extend: "tooltip",
      $resetCss: true,
    },
  },
});
usePostHog();
setupVersionCheck({ router, currentVersion: process.env.VUE_APP_BUILD_ID });
app.mount("#app");
